import React, { useEffect, useMemo, useState } from "react";
import "./Main.css";

const demoSlides = [
  {
    title:
      "Đồng Bằng Sông Mekong - Những địa điểm tuyệt vời và quản lý xuất sắc.",
    text: `Nhất định phải đến!
Hãy đến đi, cảnh quan mê hoặc, người dân thân thiện, thời gian tuyệt vời.`,
    author: "JAYS07888NF",
    rating: 5,
  },
  {
    title: "Cu Chi Tunnels - Trải nghiệm lịch sử cực kỳ ấn tượng.",
    text: `Hướng dẫn viên nhiệt tình, tour gọn gàng, đáng tiền.
Rất phù hợp cho người thích khám phá lịch sử.`,
    author: "MICHAEL_T",
    rating: 5,
  },
  {
    title: "Monkey Island - Vui và an toàn cho gia đình.",
    text: `Đi đúng lịch, dịch vụ tốt.
Các điểm chụp ảnh rất đẹp và thoải mái.`,
    author: "LISA_NG",
    rating: 5,
  },
];

export default function Main({
  leftTitleOrange = "Khám phá những viên ngọc ẩn giấu",
  leftTitleBlack = "của Việt Nam\ncùng các tour du lịch cao cấp của Siam Travel!",
  paragraphs,
  slides = demoSlides,
  googleCard = {
    name: "Jagjeet Singh Gill",
    date: "2022-11-25",
    rating: 5,
    text: "Gói tour du lịch Đồng bằng sông Mekong và hầm Củ Chi do Siam Sir cung cấp rất rẻ và chất lượng tuyệt vời. Tôi rất khuyên bạn nên sử dụng dịch vụ của công ty du lịch...",
    scoreLine: "Điểm đánh giá của Google : 4.9 trên 5,",
    basedOn: "Dựa trên 13 đánh giá",
  },
}) {
  const content = useMemo(() => {
    if (paragraphs?.length) return paragraphs;
    return [
      "Tại Siam Travel, chúng tôi chuyên tổ chức các tour du lịch cao cấp tại Việt Nam, mang đến trải nghiệm độc đáo và cá nhân hóa cho du khách. Các tour của chúng tôi tập trung khám phá những kỳ quan thiên nhiên và văn hóa của đất nước, bao gồm các điểm đến nổi tiếng như Đảo Khỉ ở Cần Giờ, các tour 1 và 2 ngày tại Đồng bằng sông Cửu Long, và Địa đạo Củ Chi. Chúng tôi cũng cung cấp dịch vụ làm thủ tục visa thuận tiện từ Thành phố Hồ Chí Minh đến cửa khẩu Mộc Bài.",
      "Việt Nam là một đất nước có lịch sử phong phú, văn hóa sôi động và vẻ đẹp thiên nhiên tuyệt vời. Là một người đam mê du lịch, tôi hiểu được mong muốn khám phá những vùng đất mới và đắm mình trong những trải nghiệm mới mẻ. Đó là lý do tại Siam Travel, chúng tôi cam kết mang đến cho khách hàng những trải nghiệm tốt nhất có thể tại Việt Nam, tập trung vào các tour du lịch cá nhân hóa và trải nghiệm sâu sắc, cho phép du khách kết nối với văn hóa và môi trường địa phương.",
      "Một trong những tour du lịch phổ biến nhất của chúng tôi là tour Đảo Khỉ ở Cần Giờ. Là một người yêu thiên nhiên, tôi đã vô cùng ấn tượng trước vẻ đẹp của Cần Giờ và quần thể khỉ hoang dã độc đáo sinh sống tại đây. Tour Đảo Khỉ của chúng tôi đưa du khách tham quan trọn ngày xuyên qua rừng ngập mặn của Cần Giờ, với cơ hội quan sát khỉ, chim và các loài động vật hoang dã khác trên đường đi. Du khách cũng có thể khám phá những bãi biển hoang sơ của hòn đảo, thưởng thức bữa trưa hải sản và tìm hiểu về văn hóa và lịch sử địa phương.",
      "Một điểm nổi bật khác trong các tour của chúng tôi là tour Đồng bằng sông Mekong. Là người yêu thích tìm hiểu văn hóa địa phương, tôi đã bị cuốn hút bởi cuộc sống thường nhật của người dân sống dọc theo dòng sông cũng như những truyền thống và ẩm thực độc đáo của vùng. Tour Đồng bằng sông Mekong của chúng tôi đưa du khách vào một hành trình khám phá mạng lưới đường thủy rộng lớn này, với cơ hội tham quan các làng mạc địa phương, thưởng thức các món ăn truyền thống và tìm hiểu về lịch sử và văn hóa của khu vực. Chúng tôi cung cấp cả tour một ngày và hai ngày tại Đồng bằng sông Mekong, để du khách có thể tùy chỉnh trải nghiệm dựa trên sở thích và thời gian của mình.",
      "Đối với những người yêu thích lịch sử, hệ thống địa đạo Củ Chi là một điểm đến không thể bỏ qua ở Việt Nam. Là một người đam mê lịch sử, tôi đã rất kinh ngạc trước những chiến thuật và chiến lược mà người Việt Nam đã sử dụng trong Chiến tranh Việt Nam. Tour nửa ngày tham quan địa đạo Củ Chi của chúng tôi bao gồm chuyến tham quan có hướng dẫn viên bên trong các đường hầm, cũng như cơ hội khám phá vùng nông thôn xung quanh và tìm hiểu về lịch sử và văn hóa địa phương.",
      "Ngoài các tour du lịch, chúng tôi cũng cung cấp dịch vụ làm thủ tục gia hạn visa tiện lợi cho du khách đến Việt Nam. Là người đã đi du lịch nhiều nơi, tôi hiểu rõ sự khó khăn khi phải làm thủ tục visa. Dịch vụ gia hạn visa của chúng tôi sẽ đưa du khách từ Thành phố Hồ Chí Minh đến cửa khẩu Mộc Bài, nơi họ có thể gia hạn visa và quay trở lại Việt Nam mà không cần phải rời khỏi đất nước.",
      "Tại Siam Travel, chúng tôi cam kết mang đến cho khách hàng những trải nghiệm du lịch chất lượng cao nhất tại Việt Nam. Chúng tôi hợp tác chặt chẽ với cộng đồng và doanh nghiệp địa phương để đảm bảo các tour du lịch của chúng tôi được thực hiện một cách có trách nhiệm và đạo đức, đồng thời khách hàng của chúng tôi có tác động tích cực đến những nơi họ đến thăm. Cho dù bạn quan tâm đến việc khám phá vẻ đẹp thiên nhiên của Việt Nam, tìm hiểu về lịch sử và văn hóa của đất nước, hay chỉ đơn giản là thư giãn trên bãi biển, chúng tôi đều có tour phù hợp với bạn. Liên hệ với chúng tôi ngay hôm nay để tìm hiểu thêm về các tour của chúng tôi và bắt đầu lên kế hoạch cho chuyến đi trong mơ của bạn đến Việt Nam.",
    ];
  }, [paragraphs]);

  const [idx, setIdx] = useState(0);

  const current = slides[idx];

  const go = (next) => {
    setIdx((prev) => {
      const n = slides.length;
      return (prev + next + n) % n;
    });
  };

  // auto slide (nhẹ nhàng)
  useEffect(() => {
    const t = setInterval(() => go(1), 6000);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <section className="ex-wrap">
      <div className="ex-grid">
        {/* LEFT */}
        <div className="ex-left">
          <h2 className="ex-title">
            <span className="ex-orange">{leftTitleOrange}</span>{" "}
            <span className="ex-black">
              {leftTitleBlack.split("\n").map((line, i) => (
                <span key={i}>
                  {line}
                  {i !== leftTitleBlack.split("\n").length - 1 && <br />}
                </span>
              ))}
            </span>
          </h2>

          <div className="ex-content">
            {content.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>
        </div>

        {/* RIGHT */}
        <div className="ex-right">
          <h3 className="ex-rightTitle">Trải nghiệm của mọi người</h3>

          {/* Testimonial slider */}
          <div className="ex-slider">
            <button
              className="ex-navBtn ex-navLeft"
              type="button"
              aria-label="Previous"
              onClick={() => go(-1)}
            >
              ‹
            </button>

            <div className="ex-card">
              <div className="ex-quoteMark" aria-hidden="true">
                “
              </div>

              <div className="ex-stars" aria-label={`${current.rating} stars`}>
                {Array.from({ length: 5 }).map((_, i) => (
                  <span
                    key={i}
                    className={`ex-star ${i < current.rating ? "on" : ""}`}
                  >
                    ★
                  </span>
                ))}
              </div>

              <div className="ex-cardTitle">{current.title}</div>
              <div className="ex-cardText">
                {current.text.split("\n").map((line, i) => (
                  <p key={i}>{line}</p>
                ))}
              </div>

              <div className="ex-bubble" aria-hidden="true" />
              <div className="ex-avatar" aria-hidden="true">
                🙂
              </div>
            </div>

            <button
              className="ex-navBtn ex-navRight"
              type="button"
              aria-label="Next"
              onClick={() => go(1)}
            >
              ›
            </button>

            <div className="ex-author">{current.author}</div>

            <div className="ex-dots" aria-label="Pagination">
              {slides.map((_, i) => (
                <button
                  key={i}
                  className={`ex-dot ${i === idx ? "active" : ""}`}
                  type="button"
                  aria-label={`Go to slide ${i + 1}`}
                  onClick={() => setIdx(i)}
                />
              ))}
            </div>
          </div>

          {/* Google review card */}
          <div className="ex-google">
            <div className="ex-gTop">
              <div className="ex-gAvatar" aria-hidden="true" />
              <div className="ex-gMeta">
                <div className="ex-gName">{googleCard.name}</div>
                <div className="ex-gDate">{googleCard.date}</div>
              </div>
              <div className="ex-gLogo" aria-hidden="true">
                G
              </div>
            </div>

            <div
              className="ex-gStars"
              aria-label={`${googleCard.rating} stars`}
            >
              {Array.from({ length: 5 }).map((_, i) => (
                <span
                  key={i}
                  className={`ex-star ${i < googleCard.rating ? "on" : ""}`}
                >
                  ★
                </span>
              ))}
            </div>

            <div className="ex-gText">{googleCard.text}</div>
            <button className="ex-gMore" type="button">
              Đọc thêm
            </button>

            <div className="ex-gBottom">
              <div>
                <span className="ex-gStrong">{googleCard.scoreLine}</span>
                <span className="ex-gStrong"> {googleCard.basedOn}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Nút chat nổi (giống ảnh) */}
      <a
        className="ex-floatChat"
        href="tel:0867394138"
        aria-label="Liên hệ với chúng tôi"
      >
        💬 <span>Liên hệ với chúng tôi</span>
      </a>
    </section>
  );
}
